import axios from 'axios';
const apiUrl = import.meta.env.VITE_API_URL;

export function getURLAPIBaseAduanall() {
  return `${apiUrl}/api/v1`;
}

const instance = axios.create({
  baseURL: getURLAPIBaseAduanall(),
  timeout: 600000,
});

instance.interceptors.request.use((config) => {
  const configuration = config;
  configuration.headers.Authorization = `Token ${getTokenAduanall()}`;
  return configuration;
});

export const getTokenAduanall = () => localStorage.getItem('aduanal_token');

// --- Facturas ---

export const startProcessInvoice = async (
  nombreArchivo,
  nombreUsuario,
  modelo,
  campos,
  nombreOriginal = ''
) => {
  try {
    return await instance.post('/factura/', {
      nombre_archivo: nombreArchivo,
      nombre_original: nombreOriginal,
      nombre_usuario: nombreUsuario,
      modelo: modelo,
      campos_extra: campos,
    });
  } catch (err) {
    return err.response;
  }
};

export const getInvoiceStatus = async (id) => {
  try {
    return await instance.get(`/factura/${id}/`);
  } catch (err) {
    return err.response;
  }
};

export const cancelarFactura = async (id) => {
  try {
    return await instance.post(`/factura/${id}/cancelar/`);
  } catch (err) {
    return err.response;
  }
};

export const getHistorialFacturas = async ({ limit = 20, offset = 0 } = {}) => {
  try {
    return await instance.get(`/factura/?limit=${limit}&offset=${offset}`);
  } catch (err) {
    return err.response;
  }
};

// --- BLs ---

export const startProcessBL = async (
  nombreArchivo,
  nombreUsuario,
  nombreOriginal = ''
) => {
  try {
    return await instance.post('/bl/', {
      nombre_archivo: nombreArchivo,
      nombre_original: nombreOriginal,
      nombre_usuario: nombreUsuario,
    });
  } catch (err) {
    return err.response;
  }
};

export const getBLStatus = async (id) => {
  try {
    return await instance.get(`/bl/${id}/`);
  } catch (err) {
    return err.response;
  }
};

export const cancelarBL = async (id) => {
  try {
    return await instance.post(`/bl/${id}/cancelar/`);
  } catch (err) {
    return err.response;
  }
};

export const getHistorialBLs = async ({ limit = 20, offset = 0 } = {}) => {
  try {
    return await instance.get(`/bl/?limit=${limit}&offset=${offset}`);
  } catch (err) {
    return err.response;
  }
};

// --- Cartas 3.1.8 ---

export const startProcessCarta = async (
  nombreArchivo,
  nombreUsuario,
  nombreOriginal = ''
) => {
  try {
    return await instance.post('/carta-318/', {
      nombre_archivo: nombreArchivo,
      nombre_original: nombreOriginal,
      nombre_usuario: nombreUsuario,
    });
  } catch (err) {
    return err.response;
  }
};

export const getCartaStatus = async (id) => {
  try {
    return await instance.get(`/carta-318/${id}/`);
  } catch (err) {
    return err.response;
  }
};

export const cancelarCarta = async (id) => {
  try {
    return await instance.post(`/carta-318/${id}/cancelar/`);
  } catch (err) {
    return err.response;
  }
};

export const getHistorialCartas = async ({ limit = 20, offset = 0 } = {}) => {
  try {
    return await instance.get(`/carta-318/?limit=${limit}&offset=${offset}`);
  } catch (err) {
    return err.response;
  }
};

const saveBlob = (blob, downloadName) => {
  const downloadUrl = window.URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = downloadUrl;
  link.setAttribute('download', downloadName);
  document.body.appendChild(link);
  link.click();
  link.remove();
  window.URL.revokeObjectURL(downloadUrl);
};

// The original needs the token header, so it is fetched as a blob and opened
// in a new tab (a plain link would arrive unauthenticated).
export const openCartaOriginal = async (id) => {
  const res = await fetch(
    `${getURLAPIBaseAduanall()}/carta-318/${id}/original/`,
    {
      headers: { Authorization: `Token ${getTokenAduanall()}` },
    }
  );
  if (!res.ok) throw new Error('No se pudo abrir el archivo original');
  const blob = await res.blob();
  if (blob.type === 'application/pdf') {
    window.open(window.URL.createObjectURL(blob), '_blank');
  } else {
    saveBlob(blob, `carta-${id}.docx`);
  }
};

export const downloadCartaJson = (id, data) =>
  saveBlob(
    new Blob([JSON.stringify(data, null, 2)], { type: 'application/json' }),
    `carta-318-${id}.json`
  );

// --- Descargas y plantillas (genéricas) ---

const downloadExcel = async (tipo, id, plantillaId, downloadName) => {
  const url = `${getURLAPIBaseAduanall()}/descargar-archivo/`;
  const formData = new FormData();
  formData.append('id', id);
  formData.append('tipo', tipo);
  if (plantillaId) {
    formData.append('plantilla_id', plantillaId);
  }
  const res = await fetch(url, {
    method: 'POST',
    headers: { Authorization: `Token ${getTokenAduanall()}` },
    body: formData,
  });
  if (!res.ok) throw new Error('Error al descargar el archivo');
  const blob = await res.blob();
  const downloadUrl = window.URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = downloadUrl;
  link.setAttribute('download', downloadName);
  document.body.appendChild(link);
  link.click();
  link.remove();
  window.URL.revokeObjectURL(downloadUrl);
};

export const downloadFacturaExcel = (id, plantillaId) =>
  downloadExcel('invoice', id, plantillaId, `factura-${id}.xlsx`);

export const downloadBLExcel = (id, plantillaId) =>
  downloadExcel('bl', id, plantillaId, `bl-${id}.xlsx`);

export const fetchPlantillas = async (tipo) => {
  try {
    const url = tipo ? `/plantillas/?tipo=${tipo}` : '/plantillas/';
    return await instance.get(url);
  } catch (err) {
    return err.response;
  }
};
